app.controller(
    'DistrictCreationController', ['$scope', '$rootScope', '$state', '$stateParams', '$translate', '$sce', '$window', '$timeout', 'DistrictService', 'HelperService', 'ExplorerService', DistrictCreationController]
);

function DistrictCreationController($scope, $rootScope, $state, $stateParams, $translate, $sce, $window, $timeout, DistrictService, HelperService, ExplorerService) {
    var vm = this;
  
    vm.DistrictVm = {};
    $scope.edit = {};
       
    $scope.desc = [
        {
            name: 'Descriptif 1',
            position: '1'
        }       
    ];
    $scope.toggleAll = function () {
        angular.forEach($scope.districts, function (itm) {
            console.log(itm);
            itm.selected = $scope.isAllSelected;
        });
    };

    $scope.optionToggled = function () {
        $scope.isAllSelected = $scope.districts.every(function (itm) {
            return itm.selected;
        });
    };
    $scope.SelecAll = function (delectAll) {
        for (var i = 0; i < $scope.item.description[0].clients.length; i++) {
            $scope.item.description[0].clients3[i].checked = delectAll;
        }
    };
    $scope.newItem = angular.copy($scope.item);

    $scope.contentTranslate = null;

    /**
     * Liste menu création
     */
    $scope.links = [
        {
            name: 'app.creationDistrict.new',
            label: 'nouveauQuartier',
            state: null // edit-valid, valid
        },
        //{
        //    name: 'app.creationDistrict.contacts',
        //    label: 'Contacts & Droits'
        //},
        {
            name: 'app.creationDistrict.classification',
            label: 'classification'
        },
        {
            name: 'app.creationDistrict.descriptif',
            label: 'descriptif'
        },
        {
            name: 'app.creationDistrict.events',
            label: 'ObjetsAssocies'
        }
        //{
        //    name: 'app.creationDistrict.visuel',
        //    label: 'Visuel'
        //},
        //{
        //    name: 'app.creationDistrict.sources',
        //    label: 'Sources & Commentaires'
        //}
    ];

    $scope.classificationBox = false;

    $scope.showOptionsBox = function (item) {
        $scope.classificationBox = true;
        $scope.placeAndEventBox = false;
        $scope.itemSelected = item;
    }

    $scope.showPlaceAndEventBox = function (item) {
        $scope.classificationBox = false;
        $scope.placeAndEventBox = true;
        $scope.itemSelected = item;
    }

    vm.LoadLists = function () {
        $scope.classifications = [
                {
                    name: 'GuideEtoile',
                    items: vm.DistrictVm.AssociatedZones
                },
                {
                    name: 'supportDeDiffusion',
                    items: vm.DistrictVm.ClientList
                }
        ];

        $scope.placeAndEvent = [
                {
                    name: 'nomLieu',
                    items: vm.DistrictVm.AssociatedPlaces
                }];
    }
       

    $scope.prevStateUrl = '';
    $scope.nextStateUrl = '';
    $scope.currentState = 0;

    angular.forEach($scope.links, function (value, key) {
        if (value.name == $state.current.name) {
            $scope.currentState = key;
            if (key > 0) {
                $scope.prevStateUrl = $scope.links[key - 1].name != '' ? $state.href($scope.links[key - 1].name) : '';
            }
            if (key < $scope.links.length - 1) {
                $scope.nextStateUrl = $scope.links[key + 1].name != '' ? $state.href($scope.links[key + 1].name) : '';
            }
        }
    });

    $scope.setCurrentState = function (index) {

        index = (index !== 'undefined') ? index : $scope.currentState;

        $scope.currentState = index;
        $scope.prevStateUrl = $scope.links[index - 1] ? ($scope.links[index - 1].name != '' ? $state.href($scope.links[index - 1].name) : '') : '';
        $scope.nextStateUrl = $scope.links[index + 1] ? ($scope.links[index + 1].name != '' ? $state.href($scope.links[index + 1].name) : '') : '';

        $state.go($scope.links[index].name);

        return false;
    };

    $scope.updateState = function (direction) {
        var index = $scope.currentState;
        switch (direction) {
            case -1:
                if (index > 0) {
                    index = $scope.currentState - 1;
                }
                break;

            case +1:
                if (index < $scope.links.length-1) {
                    index = $scope.currentState + 1;
                }
                break;
        }
        $scope.setCurrentState(index);
    }

    $scope.$on('elastic:resize', function (event, element, oldHeight, newHeight) {
        switch (element.attr("ng-model")) {
            case 'newClient.sousTitreDesc':
            case 'newItem.description[0].sousTitreDesc':
            case 'subtitleTranslate':
                element.parents('.row').find('.block-lecture .sous-titre.desc').css('height', newHeight);
                break;

            case 'newClient.txtDesc':
            case 'newItem.description[0].txtDesc':
            case 'contentTranslate':
                element.parents('.row').find('.block-lecture .text-desc').css('height', newHeight);
                break;
        }
    });


    $scope.sort = {
        column: 'position',
        descending: false
    };

    $scope.selectedCls = function (column) {
        return column === $scope.sort.column && 'sort-' + $scope.sort.descending;
    };

    $scope.changePosition = function () {
        var sort = $scope.sort;
    };

    $scope.$on('orderUp', function (event, data) {
        var dataTable = $scope.walks;
        var index = 0;

        for (var i in dataTable) {
            if (dataTable[i].title === data.element.parents('tr').find('td').html().trim()) {
                index = i;
            }
        }

        var currentPosition = dataTable[index].position;

        if (currentPosition > 1) {
            for (var i in dataTable) {
                if (dataTable[i].position === currentPosition - 1) {
                    dataTable[i].position = currentPosition;
                }
            }
            dataTable[index].position = (currentPosition - 1) + "";
        }
    });

    $scope.$on('orderDown', function (event, data) {
        var dataTable = $scope.walks;
        var index = 0;

        for (var i in dataTable) {
            if (dataTable[i].title === data.element.parents('tr').find('td').html().trim()) {
                index = i;
            }
        }

        var currentPosition = dataTable[index].position;

        if (currentPosition < dataTable.length) {
            for (var i in dataTable) {
                if (dataTable[i].position === parseInt(currentPosition) + 1) {
                    dataTable[i].position = currentPosition;
                }
            }
            dataTable[index].position = (parseInt(currentPosition) + 1) + "";
        }
    });

    $scope.current = 1;

    $scope.getCurrent = function (num) {
        $scope.current = num;
    };

    $scope.addDescSimple = function () {
        lengthDesc = $scope.desc.length + 1;
        $scope.desc.push({ name: "Description " + lengthDesc, position: lengthDesc });
    };

    $scope.delDesc = function (elm) {
        $scope.desc.splice(elm, 1);
    };

    $scope.indice = 0;

    $scope.nextDesc = function () {
        if ($scope.indice < $scope.client.length - 1) {
            $scope.indice++;
        }
    };

    $scope.prevDesc = function () {
        if ($scope.indice > 0) {
            $scope.indice--;
        }
    };
    $scope.newDescriptif = false;

    $scope.addDesc = function () {        
        $scope.newDescriptif = true;
    };

    $scope.activeDescriptif = function () {
        $scope.newDescriptif = false;
    };
    
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 10585;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $scope.useCommonCreationTopBar = true;

    initController();

    function initController() {        
        GetDistrictForCreation($rootScope.LangForWork);
    }

    function GetDistrictForCreation(lang) {
        DistrictService.GetDistrictForCreation(lang)
            .then(function (data) {
                console.log(data);
                vm.DistrictVm = data.data;
                vm.GetAssociatedZonesOnSideBar();
                vm.GetPlaceListOfCurrentZone();                
                vm.LoadLists();
                //$scope.ChangeZoneById(vm.ParamZoneId);
            });
    }

    $scope.CreateNewObject = function CreateNewSet(redirect) {
        DistrictService.CreateNewDistrict(vm.DistrictVm)
            .then(
               function success(data) {
                   if (redirect == true) {
                       $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/district?id=' + data.data + '&lang=' + $rootScope.LangForWork + '&index=0&sortKey=DistrictTitle&reverse=false&z=' + vm.ParamZoneId;
                   }
                   else {
                       $window.location.href = $rootScope.interfaceSubFolder +'/#!/creation/district/new?z=' + vm.ParamZoneId;
                       GetDistrictForCreation($rootScope.LangForWork);
                   }
               },
               function error(data) { 
               });            
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(0, $rootScope.EnumLinkType.District, $rootScope.LangForWork, true, vm.ParamZoneId)
            .then(function (data) {
                vm.DistrictVm.AssociatedZones = data;
                vm.LoadLists();
            });
    }

    vm.GetPlaceListOfCurrentZone = function () {
        HelperService.GetPlaceListOfCurrentZone(vm.ParamZoneId, $rootScope.LangForWork)
            .then(function (data) {
                vm.DistrictVm.AssociatedPlaces = data;
                vm.LoadLists();
            });
    }

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    //Updoad file - Start
    $scope.informations = {};
    $scope.informations.files = [];
    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#newupload1').trigger('click');
            }, 0, true
        );
    };
    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(files[i]);
        }
        $scope.$apply();
        $scope.uploadFiles();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };

    $scope.uploadFiles = function () {
        $scope.files = $scope.informations.files;

        if ($scope.files && $scope.files.length) {
            ExplorerService.UploadFilesForObject($scope.files)
            .then(function (response) {
                $timeout(function () {
                    vm.DistrictVm.UploadFiles = response.data.Explorer.itemList;
                });
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                //$scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            });
        }
    };
    $scope.refreshUploadList = function (files) {
        $scope.informations.files = files;
        $scope.uploadFiles();
    }
    //Updoad file - End
}